import BalanceIcon from '@mui/icons-material/Balance';
import { MenuItem } from '@src/common/components/Menu';
import {
  actionIconStyle,
  menuItemStyle,
} from '@src/orders/components/permitList/PermitActions/PermitActionsStyles';
import { OrdersNavigation } from '@src/routing/OrdersNavigation';
import type { ComponentPropsWithoutRef } from 'react';
import { forwardRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

interface Props extends ComponentPropsWithoutRef<typeof MenuItem> {
  permitId: string;
  orderId: string;
  disabled: boolean;
}
export const ProcessWithJurisdiction = forwardRef<HTMLLIElement, Props>(
  ({ permitId, orderId, disabled, ...menuItemProps }, ref) => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    const handleProcessClick = () => {
      navigate(OrdersNavigation.processPermit.url(orderId, permitId));
    };
    return (
      <>
        <MenuItem
          {...menuItemProps}
          ref={ref}
          className={menuItemStyle}
          onClick={handleProcessClick}
          disabled={disabled}
        >
          <BalanceIcon style={actionIconStyle} />
          {t('permitApplication.processWithJurisdiction')}
        </MenuItem>
      </>
    );
  },
);
